import React, { Component } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import { confirmAlert } from 'react-confirm-alert';
import { toast } from 'react-toastify';
import services from '@C/DipReading/_utils/data';
import {
  formatCurrency,
  TableGrid,
  export2Excel,
  export2PDF,
} from '@C/TableGrid';
import { FuelList } from '@C/Utils';
import DropLoaderLarge from '@C/Utils/DropLoaderLarge';
import { authHeader } from '@H';

const col = [
  {
    name: 'Date',
    key: 'time_stamp',
    sortable: true,
    type: 'date',
  },
  {
    name: 'Invoice number',
    key: 'invoice_number',
  },
  {
    name: 'Supplier Name',
    key: 'all',
    formatter(props) {
      return (
        <>
          {props.vendor_first_name} {props.vendor_last_name}
        </>
      );
    },
  },
  {
    name: 'Product',
    key: 'product',
  },
  {
    name: 'Quantity',
    key: 'total_quantity',
  },
  {
    name: 'Total amount',
    key: 'all',
    formatter(props) {
      return <>{formatCurrency(props.amount)}</>;
    },
  },
];

const enabledActions = [
  {
    action: 'Edit',
    roles: ['Site Admin', 'Dealer'],
  },
  {
    action: 'Delete',
    roles: ['Site Admin', 'Dealer'],
  },
];

class FuelPurchaseList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
      end_date: dayjs().format('YYYY-MM-DD'),
      product_id: '',
      tank_id: '',
      invoice_number: '',
      fuelPurchaseList: [],
      limit: 20,
      offset: 1,
      count: 0,
      selectedId: '',
      showModal: false,
    };

    this.limitInput = React.createRef();
  }

  componentDidMount() {
    this.getFuelPurchase();
  }

  getFuelPurchase = () => {
    services
      .getFuelPurchase(this.state)
      .then((response) => {
        this.setState({
          fuelPurchaseList: response.data.data.results,
          count: response.data.data.count,
          loading: false,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleDateChange = (e) => {
    const { name, value } = e.target;
    if (name === 'start_date' && dayjs(value).isAfter(this.state.end_date)) {
      this.setState({ [name]: value, end_date: value });
    } else if (
      name === 'end_date' &&
      dayjs(value).isBefore(this.state.start_date)
    ) {
      this.setState({ [name]: value, start_date: value });
    } else {
      this.setState({ [name]: value });
    }
  };

  handleProductChange = (e) => {
    this.setState({ product_id: e.value });
  };
  handleTankChange = (e) => {
    this.setState({ tank_id: e.value });
  };
  handleLimitChange = (e) => {
    this.setState({ limit: e.target.value });
  };
  handlePagination = (e) => {
    this.setState({ offset: e }, function () {
      this.getFuelPurchase();
    });
  };
  editItem = (selectedId) => {
    this.setState({ selectedId: selectedId, showModal: true });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  handleInvoiceNumberChange = (e) => {
    this.setState({ invoice_number: e.target.value });
  };

  handleQuickSearch = (e) => {
    if (e.target.value === '' || e.target.value === '0') {
      return;
    }
    this.setState({ limit: e.target.value, offset: 1 }, function () {
      this.getFuelPurchase();
    });
  };

  confirmDelete = (item) => {
    confirmAlert({
      title: 'Confirm transaction deletion',
      message: 'Are you sure',
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.deleteItem(item),
        },
        {
          label: 'No',
          onClick: () => false,
        },
      ],
    });
  };

  deleteItem = (item) => {
    const headers = authHeader(1);
    axios
      .delete(
        `${process.env.API_URL}/bunk/fuel-purchase/?invoice_id=${item.uuid}`,
        {
          headers,
        },
      )
      .then(() => {
        toast.success('Transaction deleted successfully', {
          position: 'bottom-center',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
        });
        this.getFuelPurchase();
      })
      .catch((error) => {
        toast.error(error.response.data.message);
      });
  };

  resetFilter = () => {
    this.setState(
      {
        start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
        end_date: dayjs().format('YYYY-MM-DD'),
        product_id: '',
        tank_id: '',
        loading: true,
        limit: 20,
        offset: 1,
        count: 0,
        invoice_number: '',
      },
      function () {
        this.getFuelPurchase();
      },
    );
  };

  submitForm = (e) => {
    e.preventDefault();
    this.setState({ loading: true }, function () {
      this.getFuelPurchase();
    });
  };

  render() {
    const { fuelPurchaseList } = this.state;
    const exportOptions = {
                        fileName: `Fuel Pruchase Report  - ${this.state.start_date} to ${this.state.end_date}`,
                        reportName: 'Fuel Purchase Report',
                        reportDate: `Date - ${dayjs(this.state.start_date).format(
                          'D MMM YY',
                        )} to ${dayjs(this.state.end_date).format('D MMM YY')}`,
                        reportQuantity: '',
                        reportSales: '',
                        reportTesting: '',
                        reportBowser: '',
                        reportTotal: '',
                        reportCustomerName: '',
                        reportGst: '',
                        reportOpeningBalance: '',
                        reportClosingBalance: '',
                        reportSaleTotal: '',
                        reportTCSTotal: '',
                      };
    return (
      <section className="widget full-width  list-table">
        <header>
          <div className="stock-info-headers">
            <h3>Fuel Purchase List ({this.state.count})</h3>
            <div className="mini-summary">
              <ul>
                <li>
                  <span>Total sale amount: </span>
                  <span>
                    {formatCurrency(
                      fuelPurchaseList.reduce(
                        (a, b) => a + (b['amount'] || 0),
                        0,
                      ) || 0,
                    )}
                  </span>
                </li>
                <li>
                  <span> Total quantity: </span>
                  <span>
                    {new Intl.NumberFormat('en-IN', {}).format(
                      fuelPurchaseList.reduce(
                        (a, b) => a + (b['total_quantity'] || 0),
                        0,
                      ) || 0,
                    )}
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div className="action">
            <button className="submit" type="submit" onClick={this.submitForm}>
              Filter
            </button>
            <button
              onClick={this.resetFilter}
              className="reset-filter"
            ></button>
          </div>
          <div className="export-btns">
            <button
              onClick={() => export2Excel(exportOptions)}
              className={`blue-btn btn-with-icon btn-with-icon__excel action-btn ${this.state.exportingExcel ? 'loading' : ''}`}
              title="Export to Excel"
            >
              Export to Excel
            </button>
            <button
              onClick={() => export2PDF(exportOptions)}
              className={`blue-btn btn-with-icon btn-with-icon__pdf action-btn ${this.state.exportingPdf ? 'loading' : ''}`}
              title="Export to PDF"
            >
              Export to PDF
            </button>
          </div>
        </header>
        <main className="list-content">
          <div className="table-filters">
            <div className="filter-wrapper">
              <div className="filter-group with-icon">
                <label>Invoice number:</label>
                <form onSubmit={this.handleQuickSearch}>
                  <input
                    type="text"
                    value={this.state.invoice_number}
                    onChange={this.handleInvoiceNumberChange}
                  />
                  <button
                    type="submit"
                    className="search-icon"
                    onClick={this.handleQuickSearch}
                  />
                </form>
              </div>
              <div className="filter-group">
                <label>From date:</label>
                <input
                  className="cstm-date-input"
                  type="date"
                  value={this.state.start_date}
                  name="start_date"
                  onChange={this.handleDateChange}
                />
              </div>
              <div className="filter-group">
                <label>To date:</label>
                <input
                  className="cstm-date-input"
                  type="date"
                  value={this.state.end_date}
                  min={this.state.start_date}
                  onChange={this.handleDateChange}
                  name="end_date"
                />
              </div>
              <div className="filter-group">
                <label>Product:</label>
                <FuelList
                  onChange={this.handleProductChange}
                  value={this.state.product_id}
                />
              </div>
            </div>
          </div>
          <div className="table-wrapper">
            {(() => {
              if (this.state.loading) {
                return <DropLoaderLarge />;
              } else {
                return (
                  <>
                    <TableGrid
                      col={col}
                      row={fuelPurchaseList}
                      offset={this.state.offset}
                      count={this.state.count}
                      limit={this.state.limit}
                      handlePagination={this.handlePagination}
                      onEdit={this.props.onEdit}
                      onDelete={this.confirmDelete}
                      enabledActions={enabledActions}
                      enableExport={false}
                      recordsFilter={this.handleQuickSearch}
                      exportOptions={{
                        fileName: `Fuel Purchase List - ${this.state.start_date} to ${this.state.end_date}`,
                        reportName: 'Fuel Purchase List',
                        reportDate: `Date - ${dayjs(
                          this.state.start_date,
                        ).format(
                          'D MMM YY',
                        )} to ${dayjs(this.state.end_date).format('D MMM YY')}`,
                        reportTotal: `Total VAT -  ${
                          fuelPurchaseList
                            .reduce((a, b) => a + (b['vat'] || 0), 0)
                            .toFixed(2) || 0
                        }`,
                        reportQuantity: `Total quantity -  ${
                          fuelPurchaseList
                            .reduce((a, b) => a + (b['total_quantity'] || 0), 0)
                            .toFixed(2) || 0
                        }`,
                        reportSales: `Total additional VAT -  ${
                          fuelPurchaseList
                            .reduce((a, b) => a + (b['additional_vat'] || 0), 0)
                            .toFixed(2) || 0
                        }`,
                        reportTesting: `Total reverse dealer commission -  ${
                          fuelPurchaseList
                            .reduce(
                              (a, b) =>
                                a + (b['reverse_dealer_commission'] || 0),
                              0,
                            )
                            .toFixed(2) || 0
                        }`,
                        reportBowser: `Total recovery for LFR/SSLF -  ${
                          fuelPurchaseList
                            .reduce(
                              (a, b) => a + (b['recovery_for_lfr_sslf'] || 0),
                              0,
                            )
                            .toFixed(2) || 0
                        }`,
                        reportCustomerName: '',
                        reportGst: '',
                        reportOpeningBalance: `Total amount -  ${
                          fuelPurchaseList
                            .reduce((a, b) => a + (b['base_amount'] || 0), 0)
                            .toFixed(2) || 0
                        }`,
                        reportClosingBalance: `Total discount -  ${
                          fuelPurchaseList
                            .reduce((a, b) => a + (b['discount'] || 0), 0)
                            .toFixed(2) || 0
                        }`,
                        reportSaleTotal: `Total sale amount -  ${
                          fuelPurchaseList
                            .reduce((a, b) => a + (b['amount'] || 0), 0)
                            .toFixed(2) || 0
                        }`,
                        reportTCSTotal: `Total TCS amount -  ${
                          fuelPurchaseList
                            .reduce((a, b) => a + (b['tcs_amount'] || 0), 0)
                            .toFixed(2) || 0
                        }`,
                      }}
                    />
                  </>
                );
              }
            })()}
          </div>
        </main>
      </section>
    );
  }
}

export { FuelPurchaseList };
